import rank from '@/components/healthnav/rank'
import info from '@/components/healthnav/info'
import getAdvice from '@/components/getAdvice.vue'

export default [{
  path:'/rank',
  name:'rank',
  meta: {
    title: '体检综合评分排行'
  },
  component:rank
}, {
  path:'/info/:eId',
  name:'info',
  meta: {
    title: '站点详情'
  },
  component:info
}, {
  path:'/info/:eId',
  name:'info',
  meta: {
    title: '站点详情'
  },
  component:info
},
  {
    path: '/getAdvice',
    name: 'getAdvice',
    component: getAdvice
  }
]



// WEBPACK FOOTER //
// ./src/router/routersplit/routerSeparate.js